export let Events = {
    TIME_PICKER_CHANGED: "timePickerChanged",
    SCHEME_CHANGED: "schemeChanged",
}

export let Schemes = {
    SECTION84: "Section84",
    SECTION85: "Section85",
    SECTION97: "Section97",
    SECTION98: "Section98",
    YOUTHSECTION32: "YouthSection32",
    YOUTHSECTION89: "YouthSection89"
}

/**
 * Returns a value indicating whether the given scheme allows Camp Supplement.
 */
export function schemeAllowsCampSupplement(scheme:string){
    return scheme === Schemes.SECTION85 || scheme === Schemes.SECTION97 || scheme === Schemes.SECTION98;
}

/**
 * Formats the given number of minutes as a human-readable duration.
 * @param balance The number of minutes, cannot be negative.
 */
export function getBalanceString(balance: number) {
    if (balance === 0) {
        return "0 minutter";
    }

    const hours = Math.trunc(balance / 60);
    const minutes = balance % 60;
    const hourText = hours === 1 ? "1 time" : `${hours} timer`;
    const minuteText = minutes === 1 ? "1 minut" : `${minutes} minutter`;

    if (hours !== 0 && minutes !== 0) {
        return `${hourText}, ${minuteText}`;
    } else if (hours !== 0) {
        return hourText;
    } else {
        return minuteText;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll<HTMLButtonElement>("button.btn-submit-guard").forEach((button) => {
        const form = button.closest("form");
        if (!form) return;

        form.addEventListener("submit", (e) => {
            const confirmMessage = button.getAttribute("data-confirm");
            if (confirmMessage && !confirm(confirmMessage)) {
                e.preventDefault();
                return;
            }

            if (form.classList.contains("is-submitting")) {
                e.preventDefault();
                return;
            }

            form.classList.add("is-submitting");
            form.querySelectorAll<HTMLButtonElement>('button[type="submit"]').forEach((btn) => {
                btn.disabled = true;
            });
        });
    });
});
